export const primaryColors = [{value: '#52c41a', name: 'Green'}, {value: '#1890ff', name: 'Blue'}, {value: '#f5222d', name: 'Red'}];

export const LIGHT_MODE_TEXT_COLOR = 'black', DARK_MODE_TEXT_COLOR = 'white';
export const DARK_MODE_COMMON_TEXT_COLOR = 'rgba(255, 255, 255, 0.65)';
export const DARK_MODE_BACKGROUND = '#000000';
export const DARK_MODE_HEADER_BACKGROUND = '#141414';
export const DARK_MODE_TABLE_HEADER = '#1d1d1d';
export const DARK_MODE_HOVER_BACKGROUND = '#262626';
export const DARK_MODE_SIDER_BACKGROUND = '#1F1F1F';
export const DARK_MODE_BORDER_COLOR = '#434343';
export const DARK_MODE_BORDER = '1px solid #434343';
export const DARK_MODE_TABLE_BORDER_COLOR = '#303030';
export const DARK_MODE_TABLE_BORDER = '1px solid #303030';
